import React from 'react';
import StartPageContent from './components/StartPage/StartPageContent';

function App() {
  return <StartPageContent />;
}

export default App;
